import { render, staticRenderFns } from "./LoginAs.vue?vue&type=template&id=1cce39b1&scoped=true&"
import script from "./LoginAs.vue?vue&type=script&lang=js&"
export * from "./LoginAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cce39b1",
  null
  
)

export default component.exports